import React, { Component, Fragment } from "react";
import { Helmet } from "react-helmet";
import { ReadData } from "../../providers/Patient.Provider";
import FileUpload from "../../util/FileUpload";
import { UPDATE_PATIENT } from "../../queries/patient.query";
import { Mutation } from "react-apollo";
import LoadingSpinner from "../../partials/loading";
import auth from "../../providers/Auth.Provider";
import { AppName, CleanMessage } from "../../util/app";
import dummyImage from "../../img/image.png";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { sendNotification } from "../../sockette";
import { ACTION_TYPE, EVENT_TARGET } from "../../event/model";

class EditPatient extends Component {
  editDetail = ReadData();
  state = {
    id: "",
    name: "",
    hcn: "",
    occupation: "",
    tel_number: "",
    email: "",
    address: "",
    gender: "",
    dob: "",
    image: "",
  };

  inputOnChangeHandler = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
  };

  UNSAFE_componentWillMount() {
    if (this.editDetail) {
      this.setState({
        id: this.editDetail.id,
        name: this.editDetail.name,
        hcn: this.editDetail.hcn,
        occupation: this.editDetail.occupation,
        tel_number: this.editDetail.telNumber,
        email: this.editDetail.email,
        address: this.editDetail.address,
        gender: this.editDetail.gender,
        dob: this.editDetail.dob,
        image: this.editDetail.profile_picture,
      });
    } else {
      this.props.history.goBack();
    }
  }

  render() {
    const title = "Edit Patient";

    return (
      <Fragment>
        <Helmet>
          <title>
            {title} | {AppName}
          </title>
          <link
            href="../../main/formlayout.css"
            rel="stylesheet"
            type="text/css"
          />
        </Helmet>

        <div className="row">
          <div className="col-md-12 col-sm-12">
            <div className="card">
              <div className="card-head">
                <header>Basic Information</header>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-3 bg-primary text-center">
                    <h5>Profile Picture</h5>
                  </div>

                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <td>
                          <div className="text-center">
                            <center>
                              <div
                                style={{
                                  backgroundImage: `url(${
                                    this.state.image || dummyImage
                                  }`,
                                  width: "100px",
                                  height: "100px",
                                }}
                                className="img-container user-img-circle"
                              ></div>
                            </center>

                            <FileUpload
                              onData={(cb) => {
                                this.setState({
                                  image: cb.path,
                                });
                              }}
                              title="Update Profile Picture"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <Mutation
                  key={this.state.id}
                  mutation={UPDATE_PATIENT}
                  onCompleted={(data) => {
                    if (data.UpdatePatient.doc) {
                      toast.success(data.UpdatePatient.message);
                      // update
                      sendNotification(
                        data.UpdatePatient.doc,
                        ACTION_TYPE.UPDATE,
                        EVENT_TARGET.PATIENT
                      );
                      this.props.history.push(
                        "/home/patient/profile/" + this.state.id
                      );
                    }
                  }}
                  onError={(err) => {
                    if (
                      err &&
                      auth.authProvider.IsAuthenticationError(err.message)
                    ) {
                      auth.authProvider.LogOut();
                      this.props.history.push("/login");
                    }
                    toast.error(CleanMessage(err.message));
                  }}
                >
                  {(updatePatient, { loading }) => (
                    <form
                      onSubmit={async (event) => {
                        event.preventDefault();
                        const { id, ...rest } = this.state;
                        await updatePatient({
                          variables: {
                            patient: id,
                            model: rest,
                          },
                        });
                      }}
                    >
                      <div className="row">
                        <div className="col-3 bg-primary text-center">
                          <h5>Basic Information</h5>
                        </div>

                        <table className="table table-bordered">
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  backgroundColor: "aliceblue",
                                }}
                              >
                                <strong>
                                  Name
                                  <span className="required"> * </span>
                                </strong>
                              </td>
                              <td>
                                <div className="col-8">
                                  <input
                                    type="text"
                                    name="name"
                                    value={this.state.name}
                                    required
                                    placeholder="enter full name"
                                    className="form-control input-height"
                                    onChange={this.inputOnChangeHandler}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  backgroundColor: "aliceblue",
                                }}
                              >
                                <strong>
                                  CSN
                                  <span className="required"> * </span>
                                </strong>
                              </td>
                              <td>
                                <div className="col-8">
                                  <input
                                    type="text"
                                    name="hcn"
                                    value={this.state.hcn}
                                    required
                                    placeholder="enter hospital care number"
                                    className="form-control input-height"
                                    onChange={this.inputOnChangeHandler}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  backgroundColor: "aliceblue",
                                }}
                              >
                                <strong>
                                  Date Of Birth
                                  <span className="required"> * </span>
                                </strong>
                              </td>
                              <td>
                                <div className="col-8">
                                  <DatePicker
                                    onChange={(date) =>
                                      this.setState({
                                        ...this.state,
                                        dob: date,
                                      })
                                    }
                                    dateFormat="MMMM dd, yyyy"
                                    className="form-control input-height w-100"
                                    selected={new Date(this.state.dob)}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  backgroundColor: "aliceblue",
                                }}
                              >
                                <strong>
                                  Gender
                                  <span className="required"> * </span>
                                </strong>
                              </td>
                              <td>
                                <div className="col-8">
                                  <select
                                    className="form-control input-height"
                                    name="gender"
                                    value={this.state.gender}
                                    onChange={this.inputOnChangeHandler}
                                    required
                                  >
                                    <option value="">Select...</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Female">Other</option>
                                  </select>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  backgroundColor: "aliceblue",
                                }}
                              >
                                <strong>
                                  Occupation
                                  <span className="required"> * </span>
                                </strong>
                              </td>
                              <td>
                                <div className="col-8">
                                  <input
                                    value={this.state.occupation}
                                    type="text"
                                    name="occupation"
                                    required
                                    placeholder="enter your occupation"
                                    className="form-control input-height"
                                    onChange={this.inputOnChangeHandler}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  backgroundColor: "aliceblue",
                                }}
                              >
                                <strong>
                                  Mobile No.
                                  <span className="required"> * </span>
                                </strong>
                              </td>
                              <td>
                                <div className="col-8">
                                  <input
                                    name="tel_number"
                                    type="tel"
                                    value={this.state.tel_number}
                                    required
                                    placeholder="mobile number"
                                    className="form-control input-height"
                                    onChange={this.inputOnChangeHandler}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  backgroundColor: "aliceblue",
                                }}
                              >
                                <strong>
                                  Email
                                  <span className="required"> * </span>
                                </strong>
                              </td>
                              <td>
                                <div className="col-8">
                                  <input
                                    type="text"
                                    className="form-control input-height"
                                    name="email"
                                    value={this.state.email}
                                    required
                                    placeholder="Email Address"
                                    onChange={this.inputOnChangeHandler}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  width: "30%",
                                  backgroundColor: "aliceblue",
                                }}
                              >
                                <strong>
                                  Address
                                  <span className="required"> * </span>
                                </strong>
                              </td>
                              <td>
                                <div className="col-12">
                                  <textarea
                                    name="address"
                                    placeholder="Home Address"
                                    required
                                    value={this.state.address}
                                    className="form-control form-control-textarea"
                                    rows="4"
                                    onChange={this.inputOnChangeHandler}
                                  ></textarea>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div className="form-body">
                        <div className="text-center">
                          <button
                            type="submit"
                            className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 margin-right-10 btn-circle btn-success"
                          >
                            Save Changes
                            <i className="material-icons">arrow_right_alt</i>
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              this.props.history.goBack();
                            }}
                            className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 margin-right-10 btn-circle btn-default"
                          >
                            <i className="material-icons text-danger">cancel</i>{" "}
                            Cancel
                          </button>
                        </div>
                      </div>
                      <div className="form-group">
                        <LoadingSpinner loading={loading} />
                      </div>
                    </form>
                  )}
                </Mutation>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default EditPatient;
